import React from "react";
import "./ZzapLink.scss";

export const ZzapLink = () => (
  <div className='zzap-link'>
    Powered by{" "}
    <span onClick={() => window.open("https://www.zzap.ru/")}>Zzap</span>
  </div>
);
